import _isEqual from 'lodash/isEqual';
import { batch } from 'react-redux';
function updateUserState(_ref) {
  let {
    dispatch,
    userDuck,
    savedInventoryDuck,
    firstName,
    lastName,
    email,
    phone,
    thumbnailUrl,
    carIds = [],
    searchIds = []
  } = _ref;
  batch(() => {
    dispatch(userDuck.creators.setUserProfile({
      firstName,
      lastName,
      email,
      phone,
      thumbnailUrl
    }));
    if (searchIds && searchIds.length > 0) {
      dispatch(userDuck.creators.setSavedSearchIds(searchIds));
    }
    if (carIds && carIds.length > 0) {
      dispatch(savedInventoryDuck.creators.setSavedInventoryItems(carIds));
    }
    dispatch(userDuck.creators.showUserState());
  });
}
function getSearchIdsFromPersonalizationUserInfo(userState) {
  return userState?.searchIds ? userState?.searchIds : [];
}
function getCombinedSearchIds(userStateA, userStateB) {
  return [...getSearchIdsFromPersonalizationUserInfo(userStateA), ...getSearchIdsFromPersonalizationUserInfo(userStateB)]?.filter((item, i, ar) => ar.indexOf(item) === i && item);
}
export default function hydrateUserInventoryActionCreator(userDuck, savedInventoryDuck, personalization) {
  return _ref2 => {
    let {
      isLoggedIn = false,
      onLoggedInStateReady = () => {}
    } = _ref2;
    return async dispatch => {
      try {
        if (isLoggedIn) {
          const userProfileCache = personalization.getUserProfileCache();
          // display header badge with cached user data
          if (userProfileCache) {
            updateUserState({
              dispatch,
              userDuck,
              savedInventoryDuck,
              personalization,
              ...userProfileCache
            });
          }
          personalization.setAuthenticated(true);
          // retrieve 'real' user data from server for domain brand and KBB brand
          const [userStateResponse, kbbUserStateResponse] = await Promise.allSettled([personalization.getUserInfo(), personalization.getUserInfo('KBB')]);
          const userState = userStateResponse?.value;
          const kbbUserState = kbbUserStateResponse?.value;
          // combine search IDs to get (AT and KBB) combined count for AT little guy seraches count
          if (userState) {
            userState.searchIds = getCombinedSearchIds(userState, kbbUserState);
          }
          if (!_isEqual(userState, userProfileCache)) {
            updateUserState({
              dispatch,
              userDuck,
              savedInventoryDuck,
              personalization,
              ...userState
            });
            // update cached user data
            personalization.setUserProfileCache(userState);
          }
        } else {
          // user is not logged in
          let savedInventory = await personalization.getSavedInventoryItems();

          // convert deprecated quick saved objects into array of ids
          // e.g. [{ listingId: 1, birfParentId: 'a'}] -> [1]
          if (savedInventory && savedInventory.length > 0 && typeof savedInventory[0] === 'object') {
            savedInventory = savedInventory.map(item => typeof item === 'object' ? item.listingId : item);
            // replace local storage
            personalization.setInventoryItems(savedInventory);
          }
          batch(() => {
            if (savedInventory && savedInventory.length > 0) {
              dispatch(savedInventoryDuck.creators.setSavedInventoryItems(savedInventory));
            }
            dispatch(userDuck.creators.showUserState());
          });
        }
        onLoggedInStateReady({
          isLoggedIn
        });
        return {
          isLoggedIn
        };
      } catch (error) {
        // show non-logged-in state
        dispatch(userDuck.creators.showUserState());
        throw Error(error);
      }
    };
  };
}